var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"is-pulled-left"},[_c('router-link',{staticClass:"button",attrs:{"to":"/dashboard"}},[_c('b-icon',{attrs:{"icon":"arrow-alt-circle-left"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }